// utils/eventBus.js
const listeners = new Set();

export const eventBus = {
  subscribe: (callback) => {
    listeners.add(callback);
    return () => listeners.delete(callback);
  },
  emit: (data) => {
    listeners.forEach((cb) => cb(data));
  },
};
